// TODO this enum should only be present in renderer worker
export const ActivityBar = 1

export const Edit = 2

export const Editor = 3

export const Explorer = 4
export const File = 5

export const Go = 6

export const Help = 7

export const ManageExtension = 8

export const OpenRecent = 9

export const Run = 10

export const Selection = 11

export const Settings = 12

export const Tab = 13

export const Terminal = 14

export const TitleBar = 15

export const View = 16

export const ActivityBarAdditionalViews = 17

export const Search = 18
